export default "/v8.63.0/8da1b91/bundles/manifest.json";